/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@gasbuddy/react-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlag } from '@fortawesome/free-solid-svg-icons';
import Modal from '../../modal';
import Notification from '../../notification';

import styles from './styles.css';

const { api, logError } = require('../../../../lib/bputils').default;
const { canReplyReview } = require('../../../../lib/permissions').default;

const canReply = canReplyReview();

export default function FlagReviewButton({ reviewId, isReportable: isReportableProps, className }) {
  const [isReportable, setIsReportable] = React.useState(isReportableProps);

  const handleOnReportReview = async () => {
    try {
      await api.post({
        path: `/reviews/${reviewId}/report`,
        data: {
          reason: 'Reported by Business Pages.',
        },
      });
      Notification.success('The Review has been flagged as inappropriate!');
      setIsReportable(true);
    } catch (err) {
      logError(err);
      Notification.error('There was an error flagging the review.');
    }
  };

  return (
    <>
      {canReply ? (
        <Modal
          title="Flag this review as inappropriate"
          className={className}
          saveButtonText="FLAG THIS REVIEW"
          onSave={handleOnReportReview}
          button={(
            <FontAwesomeIcon icon={faFlag} className={`${styles.flag} ${!isReportable ? styles.reported : ''}`} />
          )}
          gTagTitle="Flag Review"
        >
          <Text className={styles.secondaryText} centered>
          You cannot undo this action, so we just wanted to make sure you wanted to report this review for inappropriate content,
          notifying us to take a look at it. If removed from the app for inappropriate content,
          this review will be updated with a “hidden” status in the dashboard.
          </Text>
        </Modal>
      ) : null}
    </>
  );
}

FlagReviewButton.propTypes = {
  reviewId: PropTypes.number.isRequired,
  isReportable: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

FlagReviewButton.defaultProps = {
  className: '',
};
